import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getFeaturedGames,
  setFeaturedPriority,
} from "../../redux/Slices/extSlice";
import Datatable from "../mui-datatable/Datatable";

import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";
import {
  Paper,
  Button,
  Modal,
  Box,
  TextField,
  Typography,
} from "@mui/material";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 420,
  bgcolor: "#fff",
  borderRadius: "12px",
  boxShadow: 24,
  p: 4,
};

const FeaturedGames = () => {
  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [editingGame, setEditingGame] = useState(null);
  const [newPriority, setNewPriority] = useState("");
  const [currgame, setCurrgame] = useState("");

  const featuredgames = useSelector((state) => state.ext?.featuredgames?.data);

  const handleEdit = (game) => {
    setEditingGame(game[1]); // Game ID
    setCurrgame(game[2]); // Game Name
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingGame(null);
    setNewPriority("");
  };

  const handleSaveEdit = () => {
    dispatch(
      setFeaturedPriority({
        gameId: editingGame,
        priority: +newPriority,
      })
    )
      .then((data) => {
        if (data.payload?.code === 200) {
          toast.success(data.payload.message);
          dispatch(getFeaturedGames());
        } else {
          toast.error(data.payload?.message || "Something went wrong");
        }
      })
      .catch(() => {
        toast.error("Something went wrong");
      });

    handleCloseModal();
  };

  useEffect(() => {
    dispatch(getFeaturedGames());
  }, [dispatch]);

  const columns = [
  ...(featuredgames && featuredgames.length > 0
    ? Object.keys(featuredgames[0])
        .filter((key) => key !== "_id") // HIDE _id COLUMN
        .map((key) => ({
          name: key,
          label: key.charAt(0).toUpperCase() + key.slice(1),
          options: {
            filter: true,
            sort: true,
          },
        }))
    : []),

  {
    name: "Actions",
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        const game = tableMeta.rowData;

        return (
          <Button
            onClick={() => handleEdit(game)}
            startIcon={<EditIcon sx={{ fontSize: 18 }} />}
            size="small"
            sx={{
              textTransform: "none",
              color: "#4a4aff",
              fontWeight: 600,
            }}
          >
            Edit Priority
          </Button>
        );
      },
    },
  },
];

  const options = {
    selectableRows: "none",
    filter: true,
    print: false,
    download: false,
    pagination: true,
    rowsPerPage,
    rowsPerPageOptions: [5, 10, 15],
    page,
    onChangePage: (newPage) => setPage(newPage),
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
      setPage(0);
    },
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Paper
        sx={{
          width: { xs: "100%", md: "80%" },
          overflow: "hidden",
          mt: "90px",
          mr: { xs: 0, md: "25px" },
          borderRadius: "12px",
          boxShadow: "0px 3px 10px rgba(0,0,0,0.08)",
        }}
      >
        {featuredgames && (
          <Datatable
            title="Featured Games"
            data={featuredgames}
            columns={columns}
            options={options}
          />
        )}
      </Paper>

      {/* Modal */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box sx={modalStyle}>
          <Typography variant="h5" fontWeight={600} mb={1}>
            Edit Game Priority
          </Typography>

          <Typography variant="subtitle1" fontWeight={500} mb={2}>
            {currgame}
          </Typography>

          <TextField
            fullWidth
            label="Priority"
            type="number"
            value={newPriority}
            onChange={(e) => setNewPriority(e.target.value)}
            margin="normal"
          />

          <Button
            onClick={handleSaveEdit}
            variant="contained"
            fullWidth
            sx={{
              mt: 3,
              py: 1.2,
              background: "linear-gradient(90deg,#6A4FE0,#7B6CFF)",
              borderRadius: "10px",
              textTransform: "none",
              fontSize: "15px",
              "&:hover": {
                background: "linear-gradient(90deg,#5a43c5,#6a59e8)",
              },
            }}
          >
            Save Changes
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default FeaturedGames;
